/**
 * Display metadata for a review's source platform.
 *
 * Lives here rather than in a component because both the reviews list and the
 * dashboard feed render this badge, and they previously held byte-identical
 * copies of the switch — so `internal` showed as a literal "internal" chip in
 * two places and only ever got fixed in one.
 */

export interface PlatformInfo {
  label: string
  color: string
}

/**
 * Resolve the badge label and colour for a review provider.
 *
 * `internal` is our own ingestion path for scraped Google reviews, not a
 * separate source: the reviews it carries came from a Google listing, so the
 * badge says Google. Showing "internal" told the owner about our plumbing.
 */
export function getPlatformInfo(provider: string): PlatformInfo {
  switch (provider) {
    case 'google':
    case 'internal':
      return { label: 'Google', color: 'bg-blue-500' }
    case 'tripadvisor':
      return { label: 'TripAdvisor', color: 'bg-green-600' }
    case 'thefork':
      return { label: 'TheFork', color: 'bg-orange-500' }
    case 'yelp':
      return { label: 'Yelp', color: 'bg-red-500' }
    default:
      return { label: provider, color: 'bg-gray-500' }
  }
}
